import { Header2 } from 'fiducius-ui';
import styled from 'styled-components';

const AdjustedHeader = styled(Header2)`
  margin-bottom: 2rem;
`;

export default AdjustedHeader;
